import React, { useState, useEffect, useRef } from "react";
import { usePopper } from "react-popper";

import Button from "@acadia-ui/button";
import Checkbox from "@acadia-ui/checkbox";
import _ from "lodash";

import "./index.scss";
import { ButtonWithNumber } from "./ButtonWithNumber";

export const COLUMNS = {
	PRISMA: [
		{ id: "PlatformStatus", name: "Prisma Status", selected: true },
		{ id: "PrismaID", name: "Prisma ID", selected: true }
	],
	DV360: [
		{ id: "PlatformStatus", name: "DV360 Status", selected: true },
		{ id: "DV360ID", name: "DV360 ID", selected: true }
	],
	TRAFFIC_MANAGER: [
		{ id: "Status", name: "TM Status", selected: true },
		{ id: "GroupNumber", name: "Group #", selected: true }
	],
	DO_NOT_USE: { id: "DoNotUse", name: "Do Not Use", selected: true },
	GOOGLE_PLACEMENT_ID: { id: "GooglePlacementID", name: "Google Package ID", selected: true },
	GOOGLE_CAMPAIGN_MANAGER: [{ id: "PlatformStatus", name: "Google Status", selected: true }],
	IsDraft: { id: "IsDraft", name: "Draft Status", selected: true }
};

const ShowHideColumns = ({ columns = [], onSave }) => {
	// popper state/refs
	const [referenceElement, setReferenceElement] = useState(null);
	const [popperElement, setPopperElement] = useState(null);
	const { styles, attributes } = usePopper(referenceElement, popperElement, {
		placement: "bottom-end",
		modifiers: [
			{
				name: "offset",
				options: {
					offset: [0, 15]
				}
			}
		]
	});

	// internal selection and open state
	const [open, setOpen] = useState(false);
	const columnSelectionState = useRef(columns);

	// refresh state & hook is used to force a rerender when the columnSelectionState ref updates.
	const [isRefreshing, forceRefresh] = useState(true);

	useEffect(() => {
		isRefreshing && forceRefresh(!isRefreshing);
	}, [isRefreshing]);

	useEffect(() => {
		columnSelectionState.current = columns;
	}, [columns]);

	return (
		<>
			{columns?.length > 0 && !isRefreshing && (
				<ButtonWithNumber
					handleClick={() => {
						// if we're closing, reset the selection state
						if (open) {
							columnSelectionState.current = columns;
						}
						setOpen(!open);
					}}
					setReferenceElement={setReferenceElement}
					columnSelectionState={columns}
				/>
			)}
			{open && !isRefreshing && (
				<div ref={setPopperElement} style={{ ...styles.popper, zIndex: 1, width: 300 }} {...attributes.popper}>
					<div className="show-hide-columns-container">
						<div className="show-hide-columns-header">
							<span>Show/Hide Columns</span>
							<i
								className="icon-close"
								style={{ fontSize: 14, cursor: "pointer" }}
								onClick={() => {
									columnSelectionState.current = columns;
									setOpen(false);
								}}
							/>
						</div>

						<div className="show-hide-columns-body">
							{columnSelectionState?.current?.map(({ name, selected, id }) => (
								<div className="show-hide-columns-body-item" key={name}>
									{name}
									<Checkbox
										toggle
										defaultChecked={selected}
										onChange={(e, newSelectionValue) => {
											columnSelectionState.current = columnSelectionState?.current?.map((obj) => {
												return {
													id: obj.id,
													name: obj.name,
													selected: id == obj.id ? newSelectionValue : obj.selected
												};
											});
										}}
									/>
								</div>
							))}
						</div>
					</div>

					<div className="show-hide-columns-footer">
						<Button
							display="text"
							onClick={() => {
								if (columnSelectionState?.current) {
									columnSelectionState.current = columnSelectionState?.current?.map((column) => ({ ...column, selected: true })) || columnSelectionState?.current;
								}
								forceRefresh(!isRefreshing);
							}}
							data-tracking-id-alt="reset-show-hide-columns"
						>
							Reset
						</Button>

						<div>
							<Button
								display="secondary"
								onClick={() => {
									columnSelectionState.current = columns;
									setOpen(false);
								}}
								data-tracking-id-alt="cancel-show-hide-columns"
							>
								Cancel
							</Button>

							<Button
								display="primary"
								onClick={() => {
									onSave?.(columnSelectionState.current);
									setOpen(false);
								}}
								data-tracking-id-alt="apply-show-hide-columns"
							>
								Apply
							</Button>
						</div>
					</div>
				</div>
			)}
		</>
	);
};
